import { atom } from 'jotai';

/** Forecast: read the weather (map taps don't compute cones). Explore: glide cones. */
export type AppMode = 'forecast' | 'explore';

// Change it through setAppModeAtom in ./actions.ts.
export const appModeAtom = atom<AppMode>('forecast');
